import React from "react";
import { ItemList } from "schema-dts";
import JSONLDTag from "./JSONLDTag";

type Props = {
  productUrls: string[];
};

export default function JSONLDProductList(props: Props) {
  return (
    <JSONLDTag<ItemList>
      data-testid="product-list-json-ld"
      json={{
        "@context": "https://schema.org",
        "@type": "ItemList",
        numberOfItems: props.productUrls.length,
        itemListElement: props.productUrls.map((item, index) => ({
          "@type": "ListItem",
          url: item,
          position: index + 1,
        })),
      }}
    />
  );
}
